<template>
  <div v-if="moduleIsEnabled" class="core-styleguide">
    <p class="warning">This module is for development purposes only and is disabled in the production environment.</p>

    <section class="section">
      <h2 class="headline">Colors</h2>
      <div class="color-grid has-gutter">
        <div
          v-for="color in colors"
          :key="color.name"
          :style="{ backgroundColor: color.value }"
          class="box color-box"
          :class="{ 'is-dark': color.isDark }">
          {{ color.name }}<br />
          {{ color.value }}
        </div>
      </div>
    </section>

    <section class="section">
      <h2 class="headline">Typography</h2>
      <div class="typography-list has-gutter">
        <div v-for="typo in typography" :key="typo" :class="typo">
          {{ typo }}
        </div>
      </div>
    </section>

    <section class="section">
      <h2 class="headline">Box Shadows</h2>
      <div class="box-shadow-list has-gutter">
        <div
          v-for="(shadow, name) in boxShadows"
          :key="name"
          :style="{ boxShadow: shadow.value }"
          class="box box-shadow-box">
          {{ shadow.name }}
        </div>
      </div>
    </section>

    <section class="section">
      <h2 class="headline">Buttons</h2>
      <div class="button-list has-gutter">
        <UtilButton
          :blok="{
            _uid: 'button-primary-large',
            component: 'util_button',
            size: 'large',
            text: 'Primary large',
            theme: 'primary',
          }" />
        <UtilButton
          :blok="{
            _uid: 'button-primary-large-icon',
            component: 'util_button',
            size: 'large',
            text: 'Primary large',
            theme: 'primary',
          }"
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-primary-large-disabled',
            component: 'util_button',
            size: 'large',
            text: 'Primary large (disabled)',
            theme: 'primary',
          }"
          isDisabled />
        <UtilButton
          :blok="{
            _uid: 'button-primary-large-icon',
            component: 'util_button',
            size: 'large',
            text: '',
            theme: 'primary',
          }"
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-primary-large-icon',
            component: 'util_button',
            size: 'large',
            text: '',
            theme: 'primary',
          }"
          forceIcon="fi_arrow-right"
          isDisabled />
      </div>
      <div class="button-list has-gutter is-dark">
        <UtilButton
          :blok="{
            _uid: 'button-primary-large-dark',
            component: 'util_button',
            size: 'large',
            text: 'Primary large',
            theme: 'primary',
          }"
          isBackgroundDark />
        <UtilButton
          :blok="{
            _uid: 'button-primary-large-dark-icon',
            component: 'util_button',
            size: 'large',
            text: 'Primary large',
            theme: 'primary',
          }"
          isBackgroundDark
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-primary-large-dark-disabled',
            component: 'util_button',
            size: 'large',
            text: 'Primary large (disabled)',
            theme: 'primary',
          }"
          isDisabled
          isBackgroundDark />
        <UtilButton
          :blok="{
            _uid: 'button-primary-large-dark-icon',
            component: 'util_button',
            size: 'large',
            text: '',
            theme: 'primary',
          }"
          isBackgroundDark
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-primary-large-dark-disabled',
            component: 'util_button',
            size: 'large',
            text: '',
            theme: 'primary',
          }"
          isDisabled
          isBackgroundDark
          forceIcon="fi_arrow-right" />
      </div>

      <div class="button-list has-gutter">
        <UtilButton
          :blok="{
            _uid: 'button-primary-small',
            component: 'util_button',
            size: 'small',
            text: 'Primary small',
            theme: 'primary',
          }" />
        <UtilButton
          :blok="{
            _uid: 'button-primary-small-icon',
            component: 'util_button',
            size: 'small',
            text: 'Primary small',
            theme: 'primary',
          }"
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-primary-small-disabled',
            component: 'util_button',
            size: 'small',
            text: 'Primary small (disabled)',
            theme: 'primary',
          }"
          isDisabled />
        <UtilButton
          :blok="{
            _uid: 'button-primary-small-icon',
            component: 'util_button',
            size: 'small',
            text: '',
            theme: 'primary',
          }"
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-primary-small-disabled',
            component: 'util_button',
            size: 'small',
            text: '',
            theme: 'primary',
          }"
          forceIcon="fi_arrow-right"
          isDisabled />
      </div>
      <div class="button-list has-gutter is-dark">
        <UtilButton
          :blok="{
            _uid: 'button-primary-small-dark',
            component: 'util_button',
            size: 'small',
            text: 'Primary small',
            theme: 'primary',
          }"
          isBackgroundDark />
        <UtilButton
          :blok="{
            _uid: 'button-primary-small-dark-icon',
            component: 'util_button',
            size: 'small',
            text: 'Primary small',
            theme: 'primary',
          }"
          isBackgroundDark
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-primary-small-dark-disabled',
            component: 'util_button',
            size: 'small',
            text: 'Primary small (disabled)',
            theme: 'primary',
          }"
          isDisabled
          isBackgroundDark />
        <UtilButton
          :blok="{
            _uid: 'button-primary-small-dark-icon',
            component: 'util_button',
            size: 'small',
            text: '',
            theme: 'primary',
          }"
          isBackgroundDark
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-primary-small-dark-disabled',
            component: 'util_button',
            size: 'small',
            text: '',
            theme: 'primary',
          }"
          isDisabled
          isBackgroundDark
          forceIcon="fi_arrow-right" />
      </div>

      <div class="button-list has-gutter">
        <UtilButton
          :blok="{
            _uid: 'button-secondary-large',
            component: 'util_button',
            size: 'large',
            text: 'Secondary large',
            theme: 'secondary',
          }" />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-large-icon',
            component: 'util_button',
            size: 'large',
            text: 'Secondary large',
            theme: 'secondary',
          }"
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-large-disabled',
            component: 'util_button',
            size: 'large',
            text: 'Secondary large (disabled)',
            theme: 'secondary',
          }"
          isDisabled />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-large-icon',
            component: 'util_button',
            size: 'large',
            text: '',
            theme: 'secondary',
          }"
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-large-icon',
            component: 'util_button',
            size: 'large',
            text: '',
            theme: 'secondary',
          }"
          forceIcon="fi_arrow-right"
          isDisabled />
      </div>
      <div class="button-list has-gutter is-dark">
        <UtilButton
          :blok="{
            _uid: 'button-secondary-large-dark',
            component: 'util_button',
            size: 'large',
            text: 'Secondary large',
            theme: 'secondary',
          }"
          isBackgroundDark />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-large-dark-icon',
            component: 'util_button',
            size: 'large',
            text: 'Secondary large',
            theme: 'secondary',
          }"
          isBackgroundDark
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-large-dark-disabled',
            component: 'util_button',
            size: 'large',
            text: 'Secondary large (disabled)',
            theme: 'secondary',
          }"
          isDisabled
          isBackgroundDark />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-large-dark-icon',
            component: 'util_button',
            size: 'large',
            text: '',
            theme: 'secondary',
          }"
          isBackgroundDark
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-large-dark-disabled',
            component: 'util_button',
            size: 'large',
            text: '',
            theme: 'secondary',
          }"
          isDisabled
          isBackgroundDark
          forceIcon="fi_arrow-right" />
      </div>

      <div class="button-list has-gutter">
        <UtilButton
          :blok="{
            _uid: 'button-secondary-small',
            component: 'util_button',
            size: 'small',
            text: 'Secondary small',
            theme: 'secondary',
          }" />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-small-icon',
            component: 'util_button',
            size: 'small',
            text: 'Secondary small',
            theme: 'secondary',
          }"
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-small-disabled',
            component: 'util_button',
            size: 'small',
            text: 'Secondary small (disabled)',
            theme: 'secondary',
          }"
          isDisabled />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-small-icon',
            component: 'util_button',
            size: 'small',
            text: '',
            theme: 'secondary',
          }"
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-small-disabled',
            component: 'util_button',
            size: 'small',
            text: '',
            theme: 'secondary',
          }"
          forceIcon="fi_arrow-right"
          isDisabled />
      </div>
      <div class="button-list has-gutter is-dark">
        <UtilButton
          :blok="{
            _uid: 'button-secondary-small-dark',
            component: 'util_button',
            size: 'small',
            text: 'Secondary small',
            theme: 'secondary',
          }"
          isBackgroundDark />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-small-dark-icon',
            component: 'util_button',
            size: 'small',
            text: 'Secondary small',
            theme: 'secondary',
          }"
          isBackgroundDark
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-small-dark-disabled',
            component: 'util_button',
            size: 'small',
            text: 'Secondary small (disabled)',
            theme: 'secondary',
          }"
          isDisabled
          isBackgroundDark />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-small-dark-icon',
            component: 'util_button',
            size: 'small',
            text: '',
            theme: 'secondary',
          }"
          isBackgroundDark
          forceIcon="fi_arrow-right" />
        <UtilButton
          :blok="{
            _uid: 'button-secondary-small-dark-disabled',
            component: 'util_button',
            size: 'small',
            text: '',
            theme: 'secondary',
          }"
          isDisabled
          isBackgroundDark
          forceIcon="fi_arrow-right" />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#app/nuxt';
import UtilButton from '~/components/storyblok/utils/UtilButton/UtilButton.vue';

const config = useRuntimeConfig();
const moduleIsEnabled = config.public.IS_DEVELOPMENT || config.public.IS_STAGING;

const colors = [
  { name: 'red-400', value: '#ff4258', isDark: true },
  { name: 'red', value: '#ff0019', isDark: true },
  { name: 'schaerer-red', value: '#e10019', isDark: true },
  { name: 'red-dark', value: '#ad0014', isDark: true },
  { name: 'black', value: '#0d0d0d', isDark: true },
  { name: 'anthrazit', value: '#222222', isDark: true },
  { name: 'grey', value: '#696363', isDark: true },
  { name: 'steel', value: '#e6e5e5', isDark: false },
  { name: 'brown-medium', value: '#edded4', isDark: false },
  { name: 'brown-light', value: '#faf2ec', isDark: false },
  { name: 'brown-light-25', value: '#faf2ec40', isDark: false },
  { name: 'brown-light-30', value: '#faf2ec4d', isDark: false },
  { name: 'brown-light-50', value: '#faf2ec80', isDark: false },
  { name: 'brown-light-70', value: '#faf2ecb2', isDark: false },
  { name: 'brown-super-light', value: '#fcfaf8', isDark: false },
  { name: 'white', value: '#ffffff', isDark: false },
  { name: 'white-50', value: '#ffffff80', isDark: false },
  { name: 'white-30', value: '#ffffff4d', isDark: false },
  { name: 'brown-super-dark', value: '#4a301c', isDark: true },
  { name: 'brown-dark', value: '#704829', isDark: true },
  { name: 'schaerer-brown', value: '#956037', isDark: true },
  { name: 'schaerer-brown-15', value: '#95603726', isDark: false },
  { name: 'brown-super-dark-35', value: '#4a301c59', isDark: true },
  { name: 'focus-on-light', value: '#556f34', isDark: true },
  { name: 'focus-on-dark', value: '#eef7e1', isDark: false },
  { name: 'coffee-berry', value: '#af272f', isDark: true },
  { name: 'orange', value: '#ee7623', isDark: true },
  { name: 'green-coffee', value: '#789d4a', isDark: true },
  { name: 'high-yellow', value: '#fdda48', isDark: false },
  { name: 'fresh-water', value: '#00508c', isDark: true },
];

const typography = [
  'text-large-regular',
  'text-large-bold',
  'text-medium-regular',
  'text-medium-bold',
  'text-small-regular',
  'text-small-bold',
  'heading-subline',
  'heading-sub-large',
  'heading-sub-medium',
  'heading-sub-small',
  'heading-main-xlarge',
  'heading-main-large',
  'heading-main-small',
  'statement-small',
  'statement-large',
  'action-xsmall-bold',
  'action-xsmall-regular',
  'action-small-bold',
  'action-small-regular',
  'action-medium-bold',
  'action-medium-regular',
  'action-large-bold',
  'action-large-regular',
  'action-xxlarge',
  'action-xlarge',
];

const boxShadows = [
  {
    name: 'box-shadow-soft',
    value: '0px -35px 40px 0px rgba(13, 13, 13, 0.01), 0px -4px 4px 0px rgba(13, 13, 13, 0.02)',
  },
  { name: 'box-shadow-super-soft', value: '1px 1px 6.5px rgba(250, 242, 236, 0.12)' },
  { name: 'box-shadow-brown', value: '2px 2px 8px rgba(112, 72, 41, 0.12)' },
];
</script>

<style src="./CMStyleguide.scss" lang="scss" scoped />
